module.exports = __webpack_public_path__ + "img/ZF-C200 边缘计算终端.2a64f6a1.png";